// @flow

import DOM from '../../util/dom';
import window from '../../util/window';
import {extend, transformRequest} from '../../util/util';
import {getJSON, ResourceType} from '../../util/ajax';
import {ErrorEvent} from '../../util/evented';
import urls from '../../util/urls';
import Popup from '../popup';
import {ClickControlBase} from './click_control_base';
import type {Options} from './click_control_base';
import {MapMouseEvent, MapTouchEvent} from '../events';
import config from '../../util/config';

/**
 * The `TrafficCameraClickControl` adds the ability to show a popup when a Traffic Camera Icon  is clicked on.
 * @implements {IControl}
 *
 * @example
 * const trafficCameraClickControl = TrimbleMaps.TrafficCameraClickControl();
 * map.addControl(trafficCameraClickControl);
 */
class TrafficCameraClickControl extends ClickControlBase {
    constructor(options: Options) {
        const opt = extend({layerId: 'trafficcameras-traffic_cameras'}, options);
        super(opt);
    }

    _onClick(event: MapMouseEvent | MapTouchEvent) {
        // $FlowFixMe
        const features = event.features;
        if (features && features.length > 0) {
            if (features[0].properties && features[0].properties.trafficCamId) {
                const cameraId = features[0].properties.trafficCamId;
                const urlTemplate = `${urls.BASE_URL}/trafficCamera/getCameraDesc.json?id=${cameraId}&key=${config.API_KEY || ''}`;
                const requestParameters = transformRequest(urlTemplate, ResourceType.Source);
                getJSON(requestParameters, (error: ?Error, json: ?Object) => {
                    if (error) {
                        this._map.fire(new ErrorEvent(error));
                    } else if (json) {
                        const popupContentContainer = DOM.create('div', 'trimblemaps-ctrl-tcpopup');
                        const headerText = `<div>${json.name}</div><div>${json.orientation}</div>`;
                        const spinner = `<div class='trimblemaps-spinner-border trimblemaps-text-primary' role='status'><span class='trimblemaps-sr-only'>Loading...</span></div>`;
                        let popupText = `${headerText}<div class='trimblemaps-ctrl-traffic-cam trimblemaps-ctrl-traffic-cam-spinner'>${spinner}</div>`;
                        popupContentContainer.innerHTML = popupText;
                        const popup = new Popup({maxWidth: '400px'})
                            .setLngLat(features[0].geometry.coordinates)
                            .setDOMContent(popupContentContainer);
                        if (this._options.showPopup) {
                            popup.addTo(this._map);
                        }
                        const cameraImg = window.document.createElement("img");
                        const currentContext = this;
                        const display = function () {
                            popupContentContainer.innerHTML = popupText;
                            popup.setDOMContent(popupContentContainer);
                            currentContext._clickControlEventHandler();

                        };
                        cameraImg.addEventListener('load', display, {once: true});
                        cameraImg.src = json.image;
                        popupText = `${headerText}<div class='trimblemaps-ctrl-traffic-cam'>${cameraImg.outerHTML}</div>`;
                        this._popup = popup;

                    }
                });
            }
            event.preventDefault();
        }
    }
}

export default TrafficCameraClickControl;
